/* Publish by EComposer at 2024-06-06 17:33:47*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x7tw3r6vp7s"]=  window.__ectimmers["ecom-x7tw3r6vp7s"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-x7tw3r6vp7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7tw3r6vp7s', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jwcdmvfql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jwcdmvfql', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-do8ir7trhph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-do8ir7trhph', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-651z385r5pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-651z385r5pe', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2etq8yor8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2etq8yor8g', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9h0jn6vy2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9h0jn6vy2o', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uovwy1thdxg"]=  window.__ectimmers["ecom-uovwy1thdxg"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-uovwy1thdxg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uovwy1thdxg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bo2c7y1an3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bo2c7y1an3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mae4iss5jfk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mae4iss5jfk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gby662afbog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gby662afbog', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}